import Vue from 'vue'
import axios from 'axios'
import {
  baseURL,
  contentType,
  debounce,
  invalidCode,
  noPermissionCode,
  requestTimeout,
  successCode,
  tokenName,
  loginInterception,
} from '@/config'
import store from '@/store'
import qs from 'qs'
import router from '@/router'
import { isArray } from '@/utils/validate'
import { recordRoute } from '@/config'

let loadingInstance

/**
 * @description 处理code异常
 * @param {*} code
 * @param {*} msg
 */
const handleCode = (code, msg) => {
  switch (code) {
    case invalidCode:
      Vue.prototype.$baseMessage(msg || `后端接口${code}异常`, 'error')
      store.dispatch('user/resetAccessToken').catch(() => { })
      if (loginInterception) {
        location.reload()
      }
      break
    case noPermissionCode:
      router.push({ path: '/404' }).catch(() => { })
      break
    default:
      Vue.prototype.$baseMessage(msg || `后端接口${code}异常`, 'error')
      break
  }
}

const instance = axios.create({

  baseURL,
  timeout: requestTimeout,
  headers: {
    'Content-Type': contentType,
    // lang:'zh'
  },
})

instance.interceptors.request.use(
  // 请求拦截
  (config) => {
    if (config.data) {
      var token = store.getters['user/accessToken']
      // 在 headers 中添加 token
      // if (token) {
      //   config.headers['token'] = token
      // }
      config.data = {
        ...config.data,
        token: token,
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  // 响应拦截
  (response) => {
    if (loadingInstance) loadingInstance.close()

    const { data, config } = response
    const { code, msg } = data
    if (code == '-99') {
      //token验证失效的时候退出登录并重新登陆
      store.dispatch('user/logout')
      router.push('/login')
      // if (recordRoute) {
      //    store.dispatch('user/logout')
      //    const fullPath = router.fullPath
      //    router.push(`/login?redirect=${fullPath}`)
      // } else {
      //   router.push('/login')
      // }
    }

    // 操作正常Code数组
    const codeVerificationArray = isArray(successCode)
      ? [...successCode]
      : [...[successCode]]
    // 是否操作正常
    if (codeVerificationArray.includes(code)) {
      Promise.resolve(data)
      return data
    } else {
      handleCode(code, msg)
      // 返回一个对象而不是字符串
      const errorObj = {
        url: config.url,
        code: code,
        msg: msg,
        // 保留原始数据
        data: data
      }
      return Promise.reject(errorObj)
      // return Promise.reject(
      //   'vue-admin-beautiful请求异常拦截:' +
      //     JSON.stringify({ url: config.url, code, msg }) || 'Error'
      // )
    }
  },
  (error) => {
    if (loadingInstance) loadingInstance.close()
    const { response, message } = error
    if (error.response && error.response.data) {
      const { status, data } = response
      handleCode(status, data.msg || message)
      return Promise.reject(error)
    } else {
      let { message } = error
      if (message === 'Network Error') {
        message = '后端接口连接异常'
      }
      if (message.includes('timeout')) {
        message = '后端接口请求超时'
      }
      if (message.includes('Request failed with status code')) {
        const code = message.substr(message.length - 3)
        message = '后端接口' + code + '异常'
      }
      Vue.prototype.$baseMessage(message || `后端接口未知异常`, 'error')
      return Promise.reject(error)
    }
  }
)

export default instance
